import {
    insightAreaSelectPermissionHolderType,
    insightAreaRemoveOwnerViewer,
    insightAreaSearchAddOwnersViewers,
    insightAreaApplyAddOwnersViewers,
    insightAreaSelectAddOwnerViewer,
    insightAreaCancelAddOwnersViewers
} from "../../../../actions/insight-area-actions"

import buildPermissionHoldersConnector from "../../../common/permission-holders/build-permission-holders-connector"
import PermissionHoldersEditWidget from "../../../common/permission-holders/PermissionHoldersEditWidget"

export default buildPermissionHoldersConnector(
    "insightAreas",
    insightAreaSelectPermissionHolderType,
    insightAreaRemoveOwnerViewer,
    insightAreaSearchAddOwnersViewers,
    insightAreaSelectAddOwnerViewer,
    insightAreaApplyAddOwnersViewers,
    insightAreaCancelAddOwnersViewers
)(PermissionHoldersEditWidget)
